import { Box, type BoxProps } from "@chakra-ui/react";
import { KYD_AUDIENCE_DIALOG_STYLES } from "./kydAudienceDialogStyles";

const styles = KYD_AUDIENCE_DIALOG_STYLES;

type KydAudiencePanelCardProps = BoxProps & {
  children: React.ReactNode;
};

export default function KydAudiencePanelCard({
  children,
  ...boxProps
}: KydAudiencePanelCardProps) {
  return (
    <Box
      w="full"
      bg={styles.panelBg}
      border={styles.panelBorder}
      borderRadius={styles.panelRadius}
      p={styles.panelPadding}
      {...boxProps}
    >
      {children}
    </Box>
  );
}
